import { TYPES } from "../../../ProseMirrorNode.constants";

/**
 * Calculates the start and end offsets for individual nodes.
 *
 * @param {object} node
 * @param {number} previousNodeEndOffset
 * @returns {Object<{startOffset: number, endOffset: number}>}
 */
const getCurrentNodeOffsets = (node, previousNodeEndOffset) => {
  const getNodeLength = (node) => {
    switch (node?.type) {
      case TYPES.text:
        return node?.text.length;
      case TYPES.hardBreak:
        // The Read page plug-in considers hard breaks equivalent to 3 characters.
        return 3;
      case TYPES.powerWord:
      case TYPES.keyTerm:
        return node?.content?.[0]?.text?.length;
      default:
        return null;
    }
  };

  const nodeLength = getNodeLength(node);

  if (!nodeLength) {
    return {};
  }

  const startOffset = previousNodeEndOffset || 0;
  const endOffset = startOffset + nodeLength;

  return { startOffset, endOffset };
};

export default getCurrentNodeOffsets;
